import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import useFeatures from '../../hooks/useFeatures';
import { setSidebarScreen } from '../../store/sidebar/actions';
import { SidebarScreen } from '../../store/sidebar/types';
import Button from '../common/Button';
import DirectoryIcon from '../common/Icons/Directory';
// import SideBoxMenuFooter from './SideBoxMenuFooter';
import SideBoxMenuHeader from './SideBoxMenuHeader';
import SideBoxMenuItem from './SideBoxMenuItem';
import HeadphoneIcon from '../common/Icons/Headphone';
import { useCall } from '../../customer-call-sdk';

const StyledSideBoxMenu = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .sidebox-menu-body {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
        padding-top: 3rem;
        overflow-y: auto;
    }
    .make-call-btn {
        width: 80%;
        margin-bottom: 2.5rem;
        text-transform: none;
        background: #00934a;
    }
    .sidebox-menu-item {
        margin-bottom: 2.5rem;
    }
    .sidebox-menu-item span {
        margin-left: 1rem;
    }
    .icon {
        width: 32px;
        height: 32px;
    }
    .headphone-icon {
        background-color: #111;
        color: #fff;
        padding: 6px;
        border-radius: 32px;
    }
`;

const SideBoxMenu: React.FC = () => {
    const dispatch = useDispatch();
    const call = useCall();
    const features = useFeatures();

    const showScreen = (screen: SidebarScreen) => {
        dispatch(setSidebarScreen(screen));
    };

    const handleGetVideoInterpreterClick = () => {
        call.getVideoInterpreter();
    };

    const showServiceDirectory = () => {
        dispatch(setSidebarScreen('serviceDirectory'));
    };

    return (
        <StyledSideBoxMenu>
            <SideBoxMenuHeader />
            <div className="sidebox-menu-body">
                {features.call && (
                    <Button
                        className="make-call-btn"
                        size="large"
                        fullWidth
                        onClick={() => showScreen('dialpad')}
                        aria-label="Make a Call"
                    >
                        Make a Call
                    </Button>
                )}
                {features.vri && (
                    <SideBoxMenuItem
                        className="sidebox-menu-item"
                        onClick={handleGetVideoInterpreterClick}
                        role="button"
                        aria-label="Get a video interpreter button"
                    >
                        <HeadphoneIcon className="icon headphone-icon" />
                        <span>Get a video interpreter</span>
                    </SideBoxMenuItem>
                )}
                {features.directory && (
                    <SideBoxMenuItem
                        onClick={showServiceDirectory}
                        className="sidebox-menu-item"
                        role="button"
                        aria-label="Community Directory button"
                    >
                        <DirectoryIcon className="icon" />
                        <span>Community Directory</span>
                    </SideBoxMenuItem>
                )}
            </div>

            {/* <SideBoxMenuFooter /> */}
        </StyledSideBoxMenu>
    );
};

export default SideBoxMenu;
